// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1rkh3","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__YR9gl"};